function subPageCarouselFn() {
	const subPageCarouselButtons = document.querySelectorAll('.carousel-control');
	subPageCarouselButtons.forEach(function(button) {
		let currentPosition = 1;
		let carouselWrapper;

		const pageCarousel = button.parentElement.querySelector('.page-cards.active');
		if (pageCarousel != null) {
			carouselWrapper = pageCarousel.querySelector('.page-card-wrapper');
		} else {
			const imageCarousel = button.parentElement.querySelector('.image-carousel');
			carouselWrapper = imageCarousel.querySelector('.image-carousel-images-wrapper');
		}


		button.addEventListener('click', function() {
			currentPosition = carouselWrapper.getAttribute('data-current');
			const maxPosition = carouselWrapper.getAttribute('data-max');

			if (button.classList.contains('left')) {
				const otherButton = button.parentElement.querySelector('.carousel-control.right');

				if (currentPosition > 1) {
					otherButton.classList.remove('disabled');
					currentPosition = (currentPosition - 1);
					carouselWrapper.setAttribute('data-current', currentPosition);

					if (currentPosition == 1) {
						button.classList.add('disabled');
					}
				}
			} else if (button.classList.contains('right')) {
				const otherButton = button.parentElement.querySelector('.carousel-control.left');

				if (currentPosition != maxPosition) {
					otherButton.classList.remove('disabled');
					currentPosition = (+currentPosition + 1);
					carouselWrapper.setAttribute('data-current', currentPosition);

					if (currentPosition == maxPosition) {
						button.classList.add('disabled');
					}
				}
			}
		});
	});
}

const subPageCarousel = {
	init: function() {
		subPageCarouselFn();
	},
};

export default subPageCarousel;
